import { render, staticRenderFns } from "./dataTrain.vue?vue&type=template&id=75918954&scoped=true&"
import script from "./dataTrain.vue?vue&type=script&lang=js&"
export * from "./dataTrain.vue?vue&type=script&lang=js&"
import style0 from "./dataTrain.vue?vue&type=style&index=0&id=75918954&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75918954",
  null
  
)

export default component.exports